export default __webpack_public_path__ + "static/media/waterfall.56dd3b61.jpg";